import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import SetupTittle from '../SharedComponents/SetupTittle';
import SetupContainer from '../SharedComponents/SetupContainer';
import Box from '../SharedComponents/Box';
import SubmitBtn from '../SharedComponents/SubmitBtn';
import formateText from '../../../utils/Formate';

const TrackingIntegration = () => {
  const backendUrl = process.env.REACT_APP_API_URL;
  const [gtmHeadCode, setGtmHeadCode] = useState('');
  const [gtmBodyCode, setGtmBodyCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // Fetch GTM settings on component mount
  useEffect(() => {
    const fetchGtmSettings = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${backendUrl}Settings/GetGtmSettings`);
        if (response.data) {
          setGtmHeadCode(response.data.gtmHeadCode || '');
          setGtmBodyCode(response.data.gtmBodyCode || '');
        }
      } catch (error) {
        // If API doesn't exist yet or returns 404, that's okay - just use empty values
        console.log('GTM settings not found, using defaults');
        setGtmHeadCode('');
        setGtmBodyCode('');
      } finally {
        setLoading(false);
      }
    };

    fetchGtmSettings();
  }, [backendUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const response = await axios.post(`${backendUrl}Settings/SaveGtmSettings`, {
        gtmHeadCode: gtmHeadCode,
        gtmBodyCode: gtmBodyCode,
      });

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          title: 'GTM Settings Saved Successfully',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error('Error saving GTM settings:', error);
      Swal.fire({
        title: 'Error Saving GTM Settings',
        text: error.response?.data?.message || error.message || 'Please try again later.',
        icon: 'error',
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box top>
        <div className="flex justify-center items-center min-h-[400px]">
          <p className="text-xl">Loading...</p>
        </div>
      </Box>
    );
  }

  return (
    <div>
      <Box top>
        <SetupTittle text="Tracking / Integration" />
        <SetupContainer>
          <form onSubmit={handleSubmit}>
            <div className="grid lg:grid-cols-1 gap-y-4 grid-cols-1 lg:gap-y-[35px]">
              <div className="w-full min-h-20 border-black">
                <label className="font-semibold" htmlFor="gtmHeadCode">
                  {formateText('GTM Head Script')}
                </label>
                <textarea
                  id="gtmHeadCode"
                  name="gtmHeadCode"
                  value={gtmHeadCode}
                  onChange={(e) => setGtmHeadCode(e.target.value)}
                  className="w-full border-2 lg:border-[3px] pl-2 pt-2 mt-3 border-[#83430D] min-h-[200px] outline-none rounded-lg bg-transparent resize-y"
                  placeholder="Paste your GTM Head Script here (e.g., &lt;!-- Google Tag Manager --&gt;...)"
                />
                <p className="text-sm text-gray-600 mt-2">
                  This script will be inserted before the closing &lt;/head&gt; tag on all pages.
                </p>
              </div>

              <div className="w-full min-h-20 border-black">
                <label className="font-semibold" htmlFor="gtmBodyCode">
                  {formateText('GTM Body Noscript')}
                </label>
                <textarea
                  id="gtmBodyCode"
                  name="gtmBodyCode"
                  value={gtmBodyCode}
                  onChange={(e) => setGtmBodyCode(e.target.value)}
                  className="w-full border-2 lg:border-[3px] pl-2 pt-2 mt-3 border-[#83430D] min-h-[200px] outline-none rounded-lg bg-transparent resize-y"
                  placeholder="Paste your GTM Body Noscript here (e.g., &lt;noscript&gt;...&lt;/noscript&gt;)"
                />
                <p className="text-sm text-gray-600 mt-2">
                  This script will be inserted immediately after the opening &lt;body&gt; tag on all pages.
                </p>
              </div>
            </div>

            <div className="flex gap-4 mt-6">
              <SubmitBtn text={saving ? 'Saving...' : 'Save'} disabled={saving} />
            </div>
          </form>
        </SetupContainer>
      </Box>
    </div>
  );
};

export default TrackingIntegration;

